/**
 * SPEC-20260507-2030: wrappers REST pra gerenciamento de credenciais IA.
 * RBAC: backend exige `platform-master`.
 */

import { apiFetch } from "./auth";

interface ApiSuccess<T> {
  success: true;
  data: T;
}

export type SupportedProvider = "anthropic" | "openai" | "gemini" | "bedrock";

export interface CredentialView {
  provider: SupportedProvider;
  enabled: boolean;
  configured: boolean;
  envFallbackPresent: boolean;
  lastRotatedAt: string | null;
  lastUsedAt: string | null;
  lastTestStatus: "ok" | "failed" | null;
  lastTestAt: string | null;
  lastTestError: string | null;
  extraConfigKeys: string[];
}

export interface CredentialListResponse {
  cryptoEnabled: boolean;
  cryptoMessage: string;
  providers: CredentialView[];
}

export interface UpsertCredentialBody {
  apiKey: string;
  extraConfig?: Record<string, string>;
  enabled?: boolean;
}

export interface TestCredentialResponse {
  ok: boolean;
  latencyMs?: number;
  error?: string;
}

export async function listAICredentials(): Promise<CredentialListResponse> {
  const r = await apiFetch<ApiSuccess<CredentialListResponse>>("/api/admin/ai-credentials");
  return r.data;
}

export async function upsertAICredential(
  provider: SupportedProvider,
  body: UpsertCredentialBody,
): Promise<{ ok: boolean }> {
  const r = await apiFetch<ApiSuccess<{ ok: boolean }>>(
    `/api/admin/ai-credentials/${provider}`,
    { method: "PUT", body: JSON.stringify(body) },
  );
  return r.data;
}

export async function deleteAICredential(provider: SupportedProvider): Promise<void> {
  await apiFetch<ApiSuccess<{ ok: boolean }>>(`/api/admin/ai-credentials/${provider}`, {
    method: "DELETE",
  });
}

export async function testAICredential(
  provider: SupportedProvider,
): Promise<TestCredentialResponse> {
  const r = await apiFetch<ApiSuccess<TestCredentialResponse>>(
    `/api/admin/ai-credentials/${provider}/test`,
    { method: "POST", body: "{}" },
  );
  return r.data;
}
